import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {WinConfigUtilBased} from "../../../utils/WinConfigUtil";
import {NineToFive} from "../../../NineToFive";
import {NineToFiveSymbol, NineToFiveSymbolStates} from "../../../reels/symbols/NineToFiveSymbol";
import {SymbolUtils} from "../../../utils/SymbolUtils";
import {NineToFiveSound} from "../../../sound/NineToFiveSound";
import {ArrayUtils} from "../../../utils/ArrayUtils";
import {GameMode} from "@nolimit/slot-game/bin/flowcontrol/GameMode";
import {NineToFiveModel} from "../../../server/NineToFiveModel";


/**
 * Created by jonas on 2022-01-12.
 */

export class NormalWin implements SimplePresentation {

    name:string = "NormalWin";
    private controller:SimplePresentationRunnerController;

    constructor() {
    }

    shouldRun():boolean {
        return NineToFive.model.gameData.totalSpinWinnings > 0 &&
               //!NineToFive.model.gameData.brokeTheBank &&
               (NineToFive.model.data.mode == GameMode.NORMAL ||
                (NineToFive.model.data.mode != GameMode.NORMAL && NineToFive.model.winData.lines.length > 0));
    }

    start(controller:SimplePresentationRunnerController):void {
        this.controller = controller;
        const isBigWin = NineToFive.model.winData.winRatio >= 15;
        if (isBigWin) {
            this.bigWin();
        } else if (NineToFive.model.winData.lines.length > 0) {
            this.regularWin();
        } else {
            // god mode
            this.controller.setSkipCallback();
            this.controller.finish();
        }
    }

    private regularWin():void  {
        const tl = gsap.timeline({onComplete:() => {
                this.controller.setSkipCallback();
                this.controller.finish()
            }
        });

        const winSymbols = SymbolUtils.getAllSymbolsWithStateByReel(NineToFiveSymbolStates.WIN_TINY);
        const noWinSymbols =
            SymbolUtils.getAllSymbolsWithState(NineToFiveSymbolStates.NO_WIN)
            .concat((NineToFive.baseGameReelView.getAllSymbolsActually()
                                                .filter((sym) => sym.reelPosition == -1 ||
                                                                 sym.reelPosition == 4)));

        // start
        tl.add(() => {this.controller.setSkipCallback(() => {tl.seek("End", false)})})
        tl.add(noWinSymbols.map((sym) => sym.setNoWin()), 0);

        // win blink
        const wins = NineToFive.model.winData.lines;
        wins.slice().sort((a,b) => b.betWayWin.multipliedAmount - a.betWayWin.multipliedAmount).forEach((win) => {
            const blinkTl = gsap.timeline();
            const blinkSymbols =
                NineToFive.baseGameReelView.getAllSymbols()
                    .filter((sym) => win.coordinates.some((coord) => sym.reelID == coord.column &&
                                                                     sym.reelPosition == coord.row));

            blinkTl.add(blinkSymbols.map((sym) => sym.getWinBlink()));
            blinkTl.add(blinkSymbols.map((sym) => sym.setNormal()));
            tl.add(blinkTl);
            tl.add(() => NineToFive.soundPlayer.playSound("winHighlight"), '<');
        })
        tl.add(() => {}, '>0.15');

        // win animation
        const winSymbolsTl = gsap.timeline();
        winSymbols.reverse().forEach((reel) => reel.forEach((sym) => winSymbolsTl.add(sym.getWinAnimationBased(), '<')));
        if (!(NineToFive.isWinBelowStake() &&
            NineToFive.model.data.mode == GameMode.NORMAL &&
            NineToFive.model.data.nextMode == GameMode.NORMAL)) {
            tl.add(() => NineToFive.soundPlayer.playSound(sound.start));
        }
        tl.add(winSymbolsTl);

        // count up
        const configs = WinConfigUtilBased.normalLevels;
        const winLevelConfig = configs.filter((config) => config.fromRatio < NineToFive.model.winData.winRatio).pop();
        const duration = winLevelConfig!.duration;
        const sound = winLevelConfig!.sound;

        if (!(NineToFive.isWinBelowStake() &&
            NineToFive.model.data.mode == GameMode.NORMAL &&
            NineToFive.model.data.nextMode == GameMode.NORMAL) &&
            (!NineToFive.model.data.brokeTheBank || NineToFive.model.isFreespinsOutroMaxWin)) {
            tl.add(NineToFive.winView.countUpWin(NineToFive.model.winData.nonFreespinsMultipliedWin, 0, duration));
            tl.add(() => NineToFive.soundPlayer.playSound(sound.sound), '<');
            tl.add(() => NineToFive.soundPlayer.playSound(sound.end), `>${duration}`);
        }

        // end
        tl.addLabel("End");
        tl.add(noWinSymbols.map((sym) => sym.setNormal()), ">-0.2");

        tl.add(() => {
            this.controller.setSkipCallback(() => {});
        });
    }

    private bigWin():void {
        const tl = gsap.timeline({onComplete:() => {
                this.controller.setSkipCallback();
                this.controller.finish()
            }
        });

        const bigWinMusicLevel = ArrayUtils.shuffleArray([1,2,3,4]);
        bigWinMusicLevel.push(5);
        const winSymbols = SymbolUtils.getAllSymbolsWithStateByReel(NineToFiveSymbolStates.WIN_TINY);
        const noWinSymbols = SymbolUtils.getAllSymbolsWithState(NineToFiveSymbolStates.NO_WIN);

        // start
        // win blink
        const wins = NineToFive.model.winData.lines;
        wins.slice().sort((a,b) => b.betWayWin.multipliedAmount - a.betWayWin.multipliedAmount).forEach((win) => {
            const blinkTl = gsap.timeline();
            const blinkSymbols =
                NineToFive.baseGameReelView.getAllSymbols()
                    .filter((sym) => win.coordinates.some((coord) => sym.reelID == coord.column &&
                        sym.reelPosition == coord.row));

            blinkTl.add(blinkSymbols.map((sym) => sym.getWinBlink()));
            blinkTl.add(blinkSymbols.map((sym) => sym.setNormal()));
            tl.add(blinkTl);
            tl.add(() => NineToFive.soundPlayer.playSound("winHighlight"), '<');
        })
        tl.add(() => {}, '>0.15');

        // win animation
        tl.add(noWinSymbols.map((sym) => sym.setNoWin()), 0);
        const winSymbolsTl = gsap.timeline();
        winSymbols.reverse().forEach((reel) => reel.forEach((sym) => winSymbolsTl.add(sym.getWinAnimationBased(), '<')));
        tl.add(winSymbolsTl);
        tl.add(() => NineToFive.soundPlayer.fadeOutMusic(), '<');
        tl.add(() => NineToFive.soundPlayer.playSound("preBigWin"), '<');

        // count up
        if (!NineToFive.model.data.brokeTheBank || NineToFive.model.isFreespinsOutroMaxWin) {
            const winRatio = NineToFive.model.winData.winRatio;
            const configs = WinConfigUtilBased.bigLevels.filter((winLevel) => winLevel.fromRatio < winRatio);
            configs.forEach((config, index) => {
                const isFirst = index == 0;
                const isLast  = index == (configs.length - 1);
                const to      = NineToFive.model.gameData.playedBetValue * Math.min(config.toRatio, NineToFive.model.winData.winRatio);
                const from    = NineToFive.model.gameData.playedBetValue * config.fromRatio;
                tl.add(() => {
                    this.controller.setSkipCallback(() => {
                        tl.seek(`bigWinLevel${index}`, false);
                        NineToFive.soundPlayer.stopSound(`bigWinLevel${bigWinMusicLevel[index]}`);
                    });
                });
                tl.add(() => NineToFive.soundPlayer.playSound(NineToFiveSound.BIG_WIN_CHANGE));
                tl.add(() => NineToFive.soundPlayer.playSound(`bigWinLevel${bigWinMusicLevel[index]}`), '<');
                tl.add(NineToFive.winView.bigWin(to, from, index + 1, isFirst, isLast), '<');
                if (isLast) {
                    tl.add(() => NineToFive.soundPlayer.playSound(NineToFiveSound.BIG_WIN_END), '>-2.1');
                }
                tl.addLabel(`bigWinLevel${index}`, isLast ? '<' : '>');
                if (isLast) {
                    tl.add(() => {
                        this.controller.setSkipCallback(() => {});
                    }, '<');
                }
            });

            // end
            tl.add(() => NineToFive.soundPlayer.fadeInMusic());
        }

        // end
        if (NineToFive.model.data.brokeTheBank) {
            tl.add(noWinSymbols.map((sym) => sym.setNormal()));
        } else {
            tl.add(noWinSymbols.map((sym) => sym.setNormal()), ">-0.2");
        }

        tl.add(() => {
            this.controller.setSkipCallback(() => {});
        });
        tl.add(() => {}, '>0.2');
    }
}